module.exports = __webpack_public_path__ + "svg/stomach-flatter.0ac8b912987a05be7e52bbdd70cb3054.svg";